import React from 'react';
import styles from './index.module.scss';
import { Switch, Route } from 'react-router-dom';
import hasAuthorization from '../../auth/hasAuthorization'

import screens from '../../constants/screens';

// Components
import { Row, Col } from 'react-bootstrap';
import Header from '../../components/Header';
import SideTabNavigation from '../../components/SideTabNavigation';

// Screens
import DashboardScreen from '../../screens/DashboardScreen';
import SpecialsScreen from '../../screens/SpecialsScreen';
import DevicesScreen from '../../screens/DevicesScreen';
import MessagesScreen from '../../screens/MessagesScreen';
import UserScreen from '../../screens/UserScreen';
import ClockScreen from '../../screens/ClockScreen';
import RepairScreen from '../../screens/RepairScreen';
import OrderScreen from '../../screens/OrderScreen';

const Dashboard = (props) => {
    
    return (
        <div className={styles.Dashboard}>
            <Header name={props.userData.name} lastname={props.userData.lastname} logoutHandler={props.logoutHandler} />
            <Row className={styles.Body}>
                <Col xs={2} className={styles.SideTabNavigation}>
                    <SideTabNavigation />
                </Col>
                <Col className={styles.mainBodyScreen}>
                    <Switch>
                        {hasAuthorization('power_user') && <Route path={`/${screens.users}`}>
                            <UserScreen />
                        </Route>}
                        {hasAuthorization('power_user') && <Route path={`/${screens.messages}`}>
                            <MessagesScreen />
                        </Route>}
                        {hasAuthorization('admin') && <Route path={`/${screens.devices}`}>
                            <DevicesScreen />
                        </Route>}
                        {hasAuthorization('admin') && <Route path={`/${screens.specials}`}>
                            <SpecialsScreen />
                        </Route>}
                        <Route path={`/${screens.clock}`}>
                            <ClockScreen userData={props.userData} />
                        </Route>
                        <Route exact path={`/${screens.repairs}`}>
                            <RepairScreen userData={props.userData} />
                        </Route>
                        <Route path={`/${screens.repairs}/order/:orderId`}>
                            <OrderScreen
                                updateUserData={props.updateUserData} 
                                userData={props.userData} />
                        </Route>
                        <Route exact path="/">
                            <DashboardScreen />
                        </Route>
                        <Route path="*">
                            <h5>Esta pagina no existe.</h5>
                        </Route>
                    </Switch>
                </Col>
            </Row>
        </div>
    );
};

export default Dashboard;